import { render, staticRenderFns } from "./TaskIssueDianFuStepFour.vue?vue&type=template&id=6a91e138&"
import script from "./TaskIssueDianFuStepFour.vue?vue&type=script&lang=js&"
export * from "./TaskIssueDianFuStepFour.vue?vue&type=script&lang=js&"
import style0 from "./TaskIssueDianFuStepFour.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports